import React, { useEffect, useState } from 'react';
import axios from '../api/api';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import VideoSlider from "./VideoSlider";
import './Home.css';

function Home() {
    const [categories, setCategories] = useState([]);
    const [videos, setVideos] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get('/configurations/homepage');
                // Parse configValue nếu tồn tại
                const parsedData = JSON.parse(response.data.configValue || '[]');
                setCategories(Array.isArray(parsedData) ? parsedData : []);

            } catch (error) {
                console.error("Error fetching homepage data:", error);
            }
            try {
                const response = await axios.get('/configurations/videos_homepage');
                // Parse configValue nếu tồn tại
                const parsedData = JSON.parse(response.data.configValue || '[]');
                setVideos(Array.isArray(parsedData) ? parsedData : []);

            } catch (error) {
                console.error("Error fetching homepage data:", error);
            }
        };
        fetchData();
    }, []);

    return (
        <Layout>
            <div className="container">
                {/* Danh mục chính */}
                {categories.length > 0 ? (
                    categories.map((category, index) => (
                        <div
                            key={index}
                            className="mb-5 p-3 border rounded shadow-sm bg-light"
                        >
                            {/* Tiêu đề danh mục */}
                            <h4 className="mb-3 text-primary">{category.catTitle}</h4>

                            {/* Danh sách link */}
                            <div className="row">
                                {category.linkList.map((item, idx) => (
                                    <div key={idx} className="col-12 col-md-4 mb-4">
                                        <div className="card h-100">
                                            <img
                                                src={item.imageUrl}
                                                className="card-img-top"
                                                alt={item.title}
                                            />
                                            <div className="card-body">
                                                <h5 className="card-title">
                                                    <a
                                                        href={item.link}

                                                        rel="noopener noreferrer"
                                                        className="text-decoration-none text-dark"
                                                    >
                                                        {item.title}
                                                    </a>
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="text-center mt-5">Không có dữ liệu để hiển thị.</div>
                )}
            </div>

            <div className="mb-5 p-3 border rounded shadow-sm bg-light">
                {/* Tiêu đề danh mục */}
                <h4 className="mb-3 text-primary">Videos tiêu biểu</h4>

                {/* Danh sách link */}
                <div className="row">
                    <VideoSlider videos={videos} />
                </div>
            </div>

        </Layout>
    );
}

export default Home;
